import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import * as S from "./styles";
import "./styles.css";
export interface IMultiSelectCompProps {
    id: string;
    label?: string;
    options?: { label: string; value: string }[];
    textVal?: string[];
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
    errorText?: string;
}

export const MultiSelectComp = ({
    id,
    label,
    options = [],
    textVal = [],
    required,
    placeholder = "Select options",
    onCompChange,
    hasError,
    errorText,
}: IMultiSelectCompProps) => {
    const [selected, setSelected] = useState<
        { label: string; value: string }[]
    >(options.filter((opt) => textVal.includes(opt.value)));

    useEffect(() => {
        const payload = {
            value: selected.map((item) => item.value),
            valid: selected.length > 0,
            isExist: selected.every((val) =>
                options.some((opt) => opt.value === val.value)
            ),
        };
        if (selected.length > 0) {
            if (onCompChange) {
                onCompChange(id, payload);
            }
        }
    }, [selected]);

    return (
        <S.FormDiv>
            {label && (
                <label style={{ fontWeight: "bold" }}>
                    {label} {required && <sup style={{ color: "red" }}>*</sup>}
                </label>
            )}
            <MultiSelect
                options={options}
                value={selected}
                onChange={setSelected}
                labelledBy={placeholder}
                overrideStrings={{
                    selectSomeItems: placeholder,
                    allItemsAreSelected: "All selected",
                    selectAll: "Select All",
                }}
                hasSelectAll
            />
            {hasError && errorText && (
                <p
                    style={{
                        color: "red",
                        fontSize: "0.8rem",
                        marginTop: "4px",
                    }}
                >
                    {errorText}
                </p>
            )}
        </S.FormDiv>
    );
};

MultiSelectComp.defaultProps = {
    required: false,
    hasError: false,
    disabled: false,
};
